import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { setLanguage } from 'scripts/i18n/i18n';

// The gladly-language localStorage key (written by setLanguage) is the fast-boot
// source that the detector applies synchronously on first paint;
// agentPreferences.uiLanguage is the persisted copy that survives a browser data
// wipe and syncs across devices. Mirrors SetTheme.
export default class SetUiLanguage {
  constructor(context) {
    this.context = context;
  }

  run({ language }) {
    setLanguage(language);

    const preferences = this.context.stores.agentPreferences.get();
    preferences.setUiLanguage(language);
    setAgentPreferences(this.context, preferences);
  }
}
